const USER_TYPE_GUEST = 'guest user';
const USER_TYPE_CUSTOMER = 'customer user';
const USER_TYPE_PARTNER = 'partner user';
const USER_TYPE_CISCO = 'cisco user';

const USER_ACCESS_LEVEL_1 = "1";
const USER_ACCESS_LEVEL_2 = "2";
const USER_ACCESS_LEVEL_3 = "3";
const USER_ACCESS_LEVEL_4 = "4";
const USER_ACCESS_LEVEL_7 = "7";

const constants = Object.freeze({
  USER_ID_DEFAULT: 'Guest',
  USER_NAME_DEFAULT: 'Guest user',
  USER_IS_LOGGED_IN_DEFAULT: false,
  USER_EMAIL_ADDRESS_DEFAULT: null,
  USER_SESSION_ID_DEFAULT: null,
  USER_IP_ADDRESS_DEFAULT: null,
  USER_ACCESS_LEVEL_1: USER_ACCESS_LEVEL_1,
  USER_ACCESS_LEVEL_2: USER_ACCESS_LEVEL_2,
  USER_ACCESS_LEVEL_3: USER_ACCESS_LEVEL_3,
  USER_ACCESS_LEVEL_4: USER_ACCESS_LEVEL_4,
  USER_ACCESS_LEVEL_7: USER_ACCESS_LEVEL_7,
  USER_ACCESS_LEVELS: [
    USER_ACCESS_LEVEL_1,
    USER_ACCESS_LEVEL_2,
    USER_ACCESS_LEVEL_3,
    USER_ACCESS_LEVEL_4,
    USER_ACCESS_LEVEL_7
  ],
  USER_ACCESS_LEVEL_DEFAULT: USER_ACCESS_LEVEL_1,
  USER_ACCESS_LEVEL_TYPE_MAPPING: Object.fromEntries(
    new Map([
      [USER_ACCESS_LEVEL_1, USER_TYPE_GUEST],
      [USER_ACCESS_LEVEL_2, USER_TYPE_CUSTOMER],
      [USER_ACCESS_LEVEL_3, USER_TYPE_PARTNER],
      [USER_ACCESS_LEVEL_4, USER_TYPE_CISCO],
      [USER_ACCESS_LEVEL_7, USER_TYPE_PARTNER]
    ])
  ),
  USER_TYPE_GUEST: USER_TYPE_GUEST,
  USER_TYPE_CUSTOMER: USER_TYPE_CUSTOMER,
  USER_TYPE_PARTNER: USER_TYPE_PARTNER,
  USER_TYPE_CISCO: USER_TYPE_CISCO,
  USER_TYPES: [
    USER_TYPE_GUEST,
    USER_TYPE_CUSTOMER,
    USER_TYPE_PARTNER,
    USER_TYPE_CISCO
  ],
  USER_TYPE_DEFAULT: USER_TYPE_GUEST,
});

const defaults = Object.freeze({
  id: constants.USER_ID_DEFAULT,
  name: constants.USER_NAME_DEFAULT,
  emailAddress: constants.USER_EMAIL_ADDRESS_DEFAULT,
  accessLevel: constants.USER_ACCESS_LEVEL_DEFAULT,
  isLoggedInFlag: constants.USER_IS_LOGGED_IN_DEFAULT,
  sessionId: constants.USER_SESSION_ID_DEFAULT,
  IPAddress: constants.USER_IP_ADDRESS_DEFAULT,
});

function UserModelException(message) {
  this.message = message;
  this.name = 'UserModelException';
}

function getValidId(id){
  if(!!id) {
    return id;
  }
  throw new UserModelException(`Invalid user id: ${id}`);
}

function getValidName(name) {
  if(!!name && !!name.length) {
    return `${name}`.trim();
  }
  throw new UserModelException(`Invalid user name: (${name})`);
}

function getValidEmailAddress(emailAddress) {
  if(!!emailAddress && !!emailAddress.length) {
    return `${emailAddress}`.trim();
  }
}

function getValidAccessLevel(accessLevel) {
  if(constants.USER_ACCESS_LEVELS.includes(accessLevel))  {
    return accessLevel;
  }
  throw new UserModelException(`Unsupported or unknown access level (${accessLevel}).`);
}

function getValidLoggedInFlag(loggedInFlag) {
  if(loggedInFlag === true || loggedInFlag === false) {
    return loggedInFlag;
  }
  throw new UserModelException(`Invalid user loggedInFlag: (${loggedInFlag}).`)
}

function getValidSessionId(sessionId) {
  return sessionId;
}

function getValidIPAddress(IPAddress) {
  return IPAddress;
}

export default function UserModel(
  id = defaults.id,
  name = defaults.name,
  emailAddress = defaults.emailAddress,
  accessLevel = defaults.accessLevel,
  isLoggedInFlag = defaults.isLoggedInFlag,
  sessionId = defaults.sessionId,
  IPAddress = defaults.IPAddress
) {
  this.id = getValidId(id);
  this.name = getValidName(name);
  this.emailAddress = getValidEmailAddress(emailAddress);
  this.accessLevel = getValidAccessLevel(accessLevel);
  this.isLoggedInFlag = getValidLoggedInFlag(isLoggedInFlag);
  this.sessionId = getValidSessionId(sessionId);
  this.IPAddress = getValidIPAddress(IPAddress);

  this.setId = (id) => {
    this.id = getValidId(id);
  }
  this.getId = () => {
    return this.id;
  }
  this.setName = (name) => {
    this.name = getValidName(name);
  }
  this.getName = () => {
    return this.name;
  }
  this.setEmailAddress = (emailAddress) => {
    this.emailAddress = getValidEmailAddress(emailAddress);
  }
  this.getEmailAddress = () => {
    return this.emailAddress;
  }
  this.setAccessLevel = (accessLevel) => {
    this.accessLevel = getValidAccessLevel(accessLevel);
  }
  this.getAccessLevel = () => {
    return this.accessLevel;
  }
  this.setIsLoggedInFlag = (loggedInFlag) => {
    this.isLoggedInFlag = getValidLoggedInFlag(loggedInFlag);
  }
  this.isLoggedIn = () => {
    return this.isLoggedInFlag === true;
  }
  this.setSessionId = (sessionId) => {
    this.sessionId = getValidSessionId(sessionId);
  }
  this.getSessionId = () => {
    return this.sessionId;
  }
  this.setIPAddress = (IPAddress) => {
    this.IPAddress = getValidIPAddress(IPAddress);
  }
  this.getIPAddress = () => {
    return this.IPAddress;
  }
  this.isUserTypeGuest = () => {
    return constants.USER_TYPE_GUEST === constants.USER_ACCESS_LEVEL_TYPE_MAPPING[this.accessLevel];
  }
  this.isUserTypeCustomer = () => {
    return constants.USER_TYPE_CUSTOMER === constants.USER_ACCESS_LEVEL_TYPE_MAPPING[this.accessLevel];
  }
  this.isUserTypePartner = () => {
    return constants.USER_TYPE_PARTNER === constants.USER_ACCESS_LEVEL_TYPE_MAPPING[this.accessLevel];
  }
  this.isUserTypeCisco = () => {
    return constants.USER_TYPE_CISCO === constants.USER_ACCESS_LEVEL_TYPE_MAPPING[this.accessLevel];
  }
  this.getComputedType = () => {
    return constants.USER_ACCESS_LEVEL_TYPE_MAPPING[this.accessLevel];
  }

}



